<script lang="ts" setup>
import {
  defineOgImageComponent,
  useAsyncData,
  useHead,
  useI18n,
  useRoute,
  useStorage,
  useToast,
  watch,
  useSpots
} from '#imports';

import SpotView from '~~/app/blocks/SpotView.vue';

const route = useRoute();
const { showError } = useToast();
const { t } = useI18n();
const { fetchSpotBySlug } = useSpots();
const { formatedImageUrl } = useStorage();

const emit = defineEmits([
  'close',
  'pauseTimer',
  'resumeTimer',
  'resetTimer',
  'next',
  'prev',
  'subscribe',

]);

let spotSlug = route.params.spotId as string || route.params.spotSlug as string;
const {
  data: spot,
  status: spotStatus,
  refresh: spotRefresh
} = await useAsyncData(`spotBySlug:{${spotSlug}}`, async () => {
  try {
    const data =  await fetchSpotBySlug(spotSlug)
    return data
  } catch (error) {
    showError(t('messages.spots.fetchSpot'));
  }
})

watch(route, async (newRoute) => {
  spotSlug = newRoute.params.spotId as string || newRoute.params.spotSlug as string;
  spotRefresh()
});

useHead(() => ({
  name: spot.value?.name,
  meta: [
    {
      name: 'description',
      content: spot.value?.summary,
    },
  ],
}));

defineOgImageComponent('Default', {
  name: spot.value?.name,
  description:
    spot.value?.summary?.split(' ').slice(0, 10).join(' ') +
    (spot.value?.summary.length > 90 ? '...' : ''),
  imagePath: formatedImageUrl(spot.value?.cover_image_url as string, 1200, 600, 75),
});
</script>
<template>
  <SpotView
    :spot="spot"
    @prev="emit('prev')"
    @next="emit('next')"
    @close="emit('close')"
    @pause-timer="emit('pauseTimer')"
    @resume-timer="emit('resumeTimer')"
    @reset-timer="emit('resetTimer')"
    @subscribe="emit('subscribe')"
  />
</template>
